import Backbone from 'backbone'
import Tooltip from 'scoreboard/components/tooltip'
import i18n from 'scoreboard/components/i18n'

/**
 * Provides the ability to copy content of a read only input to the clipboard
 * so the user can quickly copy paste things such as an API token.
 *
 * @param {Object} options.el The container element that holds both the input
 * and button. Copy button must have the class `.copy`.
 * @param {string} options.text The text that should be copied when the button
 * is clicked.
 */

const CopyReadOnly = Backbone.View.extend({

	initialize: function(options) {
		this.options = options
		this.el = this.options.el

		this.el.find('.copy')
			.on('click', e => this.copyApiToken(e))
			.on('mouseenter', e => this.addTooltip(e))
			.on('mouseleave', () => this.removeTooltip())
	},

	addTooltip: function(e) {
		let target = this.$(e.currentTarget)
		this.tooltip = new Tooltip({
			attachTo: target,
			content: i18n.get('common.copy'),
			placement: 'above',
			arrow: 'center',
			extraClass: 'button-covert-tooltip'
		}).render()
	},

	copyApiToken: function(e) {
		this.removeTooltip()

		let target = this.$(e.currentTarget)
		this.el.find('.icon-copy').addClass('is-not-displayed')
		target.addClass('is-done')

		navigator.clipboard.writeText(this.options.text).then(() => {
			this.tooltip = new Tooltip({
				attachTo: target,
				content: i18n.get('common.copied'),
				placement: 'above',
				arrow: 'center',
				extraClass: 'button-covert-tooltip'
			}).render()
		})
	},

	removeTooltip: function() {
		this.tooltip && this.tooltip.remove()
	},

	autoRemove: true

})

export default CopyReadOnly

CopyReadOnly.__filename__ = 'components/copy-read-only.js'
